export default "__VITE_ASSET__CWVLMdux__"